"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.UnstyledInput = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _warning = _interopRequireDefault(require("warning"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _excluded = ["classes", "className", "options", "primary", "secondary"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles(theme) {
  return {
    root: {
      position: 'relative',
      minWidth: 100
    },
    indicator: {
      height: 7,
      position: 'absolute',
      right: '0.75rem',
      top: '50%'
    },
    select: {
      cursor: 'pointer',
      MozAppearance: 'none',
      WebkitAppearance: 'none',
      appearance: 'none',
      width: '100%',
      borderRadius: 0,
      minHeight: '1.5rem',
      height: 'inherit',
      padding: '1px 1.5rem 1px 1rem',
      backgroundColor: 'white',
      borderColor: '#ccc',
      '&:hover': {
        backgroundColor: '#f7f7f7',
        borderColor: '#999'
      }
    },
    primary: _objectSpread({}, theme.typography.form1),
    secondary: _objectSpread({}, theme.typography.form2)
  };
};

var UnstyledInput = function UnstyledInput(props) {
  var _clsx;

  var classes = props.classes,
      className = props.className,
      options = props.options,
      primary = props.primary,
      secondary = props.secondary,
      rest = _objectWithoutProperties(props, _excluded);

  (0, _warning["default"])(!(primary && secondary), 'Input cannot be Primary and Secondary simultaneously');
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx2["default"])(classes.root, className)
  }, /*#__PURE__*/_react["default"].createElement("select", _extends({
    className: (0, _clsx2["default"])(classes.select, (_clsx = {}, _defineProperty(_clsx, classes.primary, primary), _defineProperty(_clsx, classes.secondary, secondary), _clsx))
  }, rest), options.map(function (opt, index) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      value: (0, _isUndefined["default"])(opt.value) ? opt.key : opt.value,
      key: (0, _isUndefined["default"])(opt.key) ? opt.value + index : opt.key
    }, (0, _isUndefined["default"])(opt.text) ? opt.value : opt.text);
  })), /*#__PURE__*/_react["default"].createElement("svg", {
    className: classes.indicator,
    viewBox: "0 0 4 4"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0,0 2,2 4,0 z",
    fill: "black"
  })));
};

exports.UnstyledInput = UnstyledInput;
UnstyledInput.defaultProps = {
  classes: {},
  options: [],
  onChange: function onChange() {},
  value: ''
};
UnstyledInput.propTypes = {
  classes: _propTypes["default"].any,
  className: _propTypes["default"].string,
  primary: _propTypes["default"].bool,
  secondary: _propTypes["default"].bool,
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].any.isRequired,
    text: _propTypes["default"].any,
    key: _propTypes["default"].any
  })).isRequired
};

var _default = (0, _reactJss["default"])(styles)(UnstyledInput);

exports["default"] = _default;